<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/kakusan/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>隱私權條款</h1>
        </div>
      </header>
      <section class="main-section py-5">
        <div class="container">
          <div id="body">
            <!-- <h1>我的行動富地滋 - 隱私權政策</h1> -->
            <p class="update">更新時間：2019.10 v1.0</p>
            <p>
              親愛的會員，您個人的隱私權，日商富地滋股份有限公司台灣分公司絕對尊重並予以保護。
            </p>
            <p>
              為了幫助您瞭解日商富地滋股份有限公司台灣分公司如何透過「我的行動富地滋」（以下簡稱本APP）蒐集、使用及保護您所提供的個人資訊，請您詳細閱讀隱私權保護政策。
            </p>
            <h3>一、個人資料的蒐集目的</h3>
            <p>
              基於優化服務體驗之目的，建立使用者支付管道並進行客戶管理與業務行銷，本公司將透過隱私權保護政策，蒐集、處理並利用使用者於本APP使用過程中所產生之個人資料，並對其進行加值運用。
            </p>
            <p class="small">
              （上述特定目的，法定編號包含：〇六七
              信用卡、現金卡、轉帳卡或電子票證業務、〇八一
              個人資料之合法交易業務、〇九〇 消費者、客戶管理與服務、〇九一
              消費者保護、〇九八 商業與技術資訊、一三五 資（通）訊服務、一三六
              資（通）訊與資料庫管理、一五二 廣告或商業行為管理、一五七
              調查、統計與研究分析、一八一
              其他經營合於營業登記項目或組織章程所定之業務）
            </p>
            <h3>二、個人資料的取得</h3>
            <ol>
              <li>
                當您註冊成為本 APP 會員時，會要求您輸入手機號碼與電子信箱。
              </li>
              <li>
                當您在使用本 APP 服務時，本公司可能會蒐集到以下資料：
                <ol>
                  <li>
                    得以辨識您個人之資料，例如：姓名、住址、行動電話、電子簽章、憑證序號、提供網路身分認證或申辦查詢服務之記錄及其他任何可辨識資料本人者。
                  </li>
                  <li>
                    得以辨識您財務之資料，例如：金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼、保險單號碼、個人之其他號碼或帳戶等。
                  </li>
                  <li>
                    政府資料得以辨識個人者，例如：身分證統一編號、統一證號、稅籍編號、保險憑證號碼、車牌號碼等。
                  </li>
                  <li>
                    其他使用者因使用本 APP 所產生之技術數據，例如：IP
                    地址、登錄時間、位置資料、財務交易資訊以及其他得以辨識個人休閒活動及興趣、生活格調等之資料。
                  </li>
                </ol>
              </li>
            </ol>
            <p class="small">
              （上述資料之類別，法定編號包含：C〇〇一 辨識個人者、C〇〇二
              辨識財務者、C〇〇三 政府資料中之辨識者、C〇三五
              休閒活動及興趣、C〇三六 生活格調、C〇九三 財務交易）
            </p>
            <h3>三、個人資料利用之期間、地區、對象及方式</h3>
            <p>本公司收集到的資料，將做如下處理：</p>
            <ol>
              <li>
                您所提供的基本個人資料（如姓名），將做為會員身分判定的依據；您所提供的信用卡卡號，將作為提供信用卡優惠資訊服務的依據。
              </li>
              <li>
                您的使用資料及技術資料，將作為改進本 APP 服務或開發新服務用。
              </li>
              <li>
                本公司將透過行動推播或寄送電子郵件之方式，分享本公司及合作廠商之優惠消息。若您不希望收到本公司及合作廠商之優惠消息，可隨取消通知服務。如您於設定上有任何問題，歡迎隨時與本公司聯繫。
              </li>
              <li>
                本公司可能與第三方共用綜合性的非個人資料。「綜合性非個人資料」是指記錄有關用戶的並被分組收集的資料，這些資料在經過分組後不再反映或指向某個特定的可被辨識的使用者。上述資訊之處理與利用，可能由本公司之關係企業或其他合作夥伴進行，或於台灣外發生。除非有當地法律除外情況，本公司不會將這些資訊用做其他用途。本公司亦不會未經會員事先同意向第三者透露其個人資料，但因國家重大利益或為配合執法機關調查而根據法律而需要透露者則除外。
              </li>
              <li>
                上述之資料除綜合性非個人資料外，本公司將於使用者終止會員服務時進行刪除。
              </li>
            </ol>
            <h3>四、個人資料的自主權</h3>
            <ol>
              <li>
                您本人可查詢、複製、申請變動或閱覽屬於您的個人資料，若非本人或於本公司尚未查證您為本人前，您不得申請查詢、複製、請求閱覽或申請變動不屬於本帳號之個人資料及帳號服務。如非前述情況之申請者，必要時您將提供相關個人資料及書面資訊，使本公司可協助處理作業程序。
              </li>
              <li>
                您本人可要求停止蒐集、處理、利用或刪除屬於您的個人資料；但一經停止或刪除，您將無法繼續使用本
                APP 的服務。
              </li>
              <li>
                於妨害國家重大利益、妨害公務機關執行法定職務、妨害蒐集機關或第三人重大利益時，本公司有權拒絕您主動提出變更、刪除或異動個人資料之請求。
              </li>
            </ol>
            <h3>五、個人資料的安全</h3>
            <ol>
              <li>為保護您的隱私，本公司提供必要之技術及措施保護個人資料。</li>
              <li>您的個人資料、註冊帳號及密碼等，請您妥善保管，避免外洩。</li>
              <li>您的信用卡資料，請您妥善保管，避免為他人之不法用途。</li>
              <li>
                您同意在註冊成為本 APP
                會員時所留存的資料與事實相符，如嗣後發現你的個人資料遭他人非法使用或有任何異常時，應即時通知本公司。
              </li>
              <li>
                您同意於使用本 APP
                服務時，所提供及使用之資料皆為合法，並無侵害第三人權利、違反第三方協議或涉及任何違法行為。如因使用服務而致第三人損害，除本公司故意或重大過失外，本公司並不負擔相關賠償責任。
              </li>
            </ol>
            <h3>六、隱私權及個人資料保護政策的修訂與效力</h3>
            <ol>
              <li>
                本公司將不定時更新本政策，並遵循中華民國隱私權與個人資料保護相關法令。
              </li>
              <li>本政策構成會員條款的一部分。</li>
              <li>
                如您不同意本政策之任何條款或修改變更之內容，請您立即停止使用本
                APP。
              </li>
              <li>
                如您對本公司的隱私權或個人資料保護政策有任何問題，請聯絡客服：(02)2563-6556
              </li>
            </ol>
          </div>
        </div>
      </section>
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
export default {
  name: "PrivacyScreen",
  components: {
    PublicLayout,
  },
};
</script>
